<template>
    <div>
        <div class="tabTit">
          <div>
              <p>项目排名</p>
          </div>
          </div>

          <div class="projectBlock" style="padding-bottom: 60px;">
          <el-table
          :data="tableData"
          tooltip-effect="dark"
          stripe
          class="fontSize"
          :header-cell-style="{ background: '#3867d6',color:'#fff' }"
          >
        
          <el-table-column
            type="index"
            label="排名"
            align="center"
            width="100">
          </el-table-column>

          <el-table-column
            prop="title"
            label="项目名称"
            align="center">
          </el-table-column>

          <el-table-column
            prop="pro_leader"
            label="项目负责人"
            align="center">
          </el-table-column>

          <el-table-column
            prop="typeName"
            label="项目类型"
            align="center">
          </el-table-column>

          <el-table-column
            prop="fund"
            label="总预算(元)"
            align="center">
            <template #default="scope">
              <div>
                {{ scope.row.fund }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="collage"
            label="所属学院"
            align="center">
          </el-table-column>
      
        </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        props:['tableData'],
    }
</script>

<style lang="less">
  .el-table__header{
    height:60px;
  }
  .el-table__row{
    height: 60px;
  }
</style>